import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, Group } from "@/components/ui";

export function RolesHeader({
  total,
  personalizados,
  modoCrear,
  onIniciarCrear,
}: {
  total: number;
  personalizados: number;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Gestión de roles"
      description={`${total} roles (${personalizados} personalizados) · los 7 roles del sistema tienen permisos fijos; a los personalizados les asignas los permisos que otorgan.`}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nuevo rol
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
